<template>
  <tr :class="{'is-marked': marked}">
    <td class="text-center">
      <DamageRating
        :is-exo-user="policyUpdate"
        :has-revision="hasRevision"
        :inspectionRating="rating"
        :inspectionOverride="override"
        :remediation="remediation"
        :client-remediated-rating="clientRemediatedRating"
        :remediation-preview-rating="remediationPreviewRating"
        :show-in-preview-mode="showInPreviewMode"
      />
    </td>

    <td
      v-if="showFindingNameColumn"
    >
      <DetailsButton
        title="Finding Details"
        entity-type="findingDetails"
        :entity="id"
        :args="{showInPreviewMode: this.showInPreviewMode}"
      >
        <a
          :href="findingUrl"
          title="Finding"
        >{{displayName}}</a>
      </DetailsButton>
    </td>

    <td>
      <template v-if="showFindingNameColumn">
        <template v-if="canViewFindingTypeDetails">
          <a
            :href="findingTypeUrl"
            title="Finding"
          >{{findingType.name}}</a>
        </template>
        <template v-else>
          {{findingType.name}}
        </template>
      </template>
      <template v-else>
        <DetailsButton
          title="Finding Details"
          entity-type="findingDetailsSimple"
          :entity="id"
          :args="{showEntityDetailsActions: this.showFindingNameColumn}"
        >
          {{findingType.name}}
        </DetailsButton>
      </template>
    </td>

    <td>
      <a 
        :href="assetUrl" 
        title="Details"
      >{{component.physicalAsset.name}}</a>
    </td>

    <td>
      <a
        :href="componentUrl"
        title="Details"
      >{{component.name}}</a>
    </td>

    <td>{{ h$.formatDate.short(inspection.date) }}</td>

    <td class="text-center">
      <span
        v-if="photoCount > 0"
        class="indicator-images"
        title="Finding Photos" 
        data-action="show-details" 
        data-entity-type="findingPhotos"
        :data-entity="id"
        :data-row="rowRef"
      ></span>
    </td>

    <td class="table-row-actions">
      <RowAction
        :href="findingUrl"
        action="read"
      />

      <RowAction
        v-if="policyUpdate"
        :href="findingUrl + '/edit'"
        action="update"
      />

      <RowAction
        v-if="policyUpdate"
        :href="findingUrl"
        action="delete"
      />
    </td>
  </tr>
</template>

<script>
import Row from "../shared/grid/row";
import RowAction from "../shared/grid/row_action";
import DetailsButton from "../shared/grid/details_button";
import DamageRating from "../shared/damage_rating";

import helpers from "../../helpers.js";

export default {
  extends: Row,

  components: {
    RowAction,
    DamageRating,
    DetailsButton
  },

  props: {
    filter: Object,
    rating: Number,
    clientRating: Number,
    remediatedRating: Number,
    clientRemediatedRating: Number,
    remediationPreviewRating: Number,
    id: String,
    displayName: String,
    component: Object,
    inspection: Object,
    photoCount: Number,
    findingType: Object,
    remediation: Object,
    override: Object,
    hasRevision: Boolean,
    policyUpdate: Boolean,
    showFindingNameColumn: Boolean,
    showInPreviewMode: Boolean
  },

  setup () {
    return {
      h$: helpers
    }
  },

  computed: {
    isFilterEmpty: function() {    
      return (Object.keys(this.filter).filter(x => !["historical", "siteId"].includes(x))).length === 0;
    },

    findingUrl: function () {
      return "/findings/" + this.id
    },

    findingTypeUrl: function () {
      return "/finding_types/" + this.findingType.id
    },

    assetFilterQueryParams: function() {
      let filterParams = Object.assign({}, this.filter);
      
      delete filterParams.siteId;
      delete filterParams.physicalAssetTypeId;

      filterParams.physicalAssetId = this.component.physicalAsset.id;

      return (!this.isFilterEmpty) ? "?v-filter=" + JSON.stringify(filterParams) : "";
    },

    assetUrl: function () {
      return "/physical_assets/" + this.component.physicalAsset.id + this.assetFilterQueryParams;
    },

    componentFilterQueryParams: function() {
      let filterParams = Object.assign({}, this.filter);
      
      delete filterParams.siteId;
      delete filterParams.physicalAssetTypeId;
      delete filterParams.physicalAssetId;

      filterParams.componentId = this.component.id;

      return (!this.isFilterEmpty) ? "?v-filter=" + JSON.stringify(filterParams) : "";
    },

    componentUrl: function () {
      return "/components/" + this.component.id + this.componentFilterQueryParams;
    },

    canViewFindingTypeDetails: function () {
      return this.policyUpdate && this.showFindingNameColumn
    },
  }
}
</script>
